import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from 'react-bootstrap';
import { formatRun } from '../../../../shared/utils/run';

const RunDropdown = ({
    list,
    handleChange,
    disabled,
    rowNumber,
    selectedRunId,
    isSpecial,
    impactedRuns,
}) => (
    <div>
        {isSpecial &&
            impactedRuns.length > 0 &&
            impactedRuns.map(run => (
                <p style={{ marginTop: 14 }} key={run.runId}>
                    {formatRun(run)}
                </p>
            ))}
        {isSpecial &&
            impactedRuns.length === 0 && <p style={{ marginTop: 14 }}>No run selected.</p>}
        {!isSpecial && (
            <FormControl
                componentClass="select"
                onChange={e => handleChange(e.target.value, rowNumber)}
                disabled={disabled}
                value={selectedRunId || ''}
            >
                <option value="">Select Run</option>
                {list.map(run => (
                    <option key={run.runId} value={run.runId}>
                        {formatRun(run)}
                    </option>
                ))}
            </FormControl>
        )}
    </div>
);

RunDropdown.propTypes = {
    list: PropTypes.array,
    handleChange: PropTypes.func,
    disabled: PropTypes.bool,
    selectedRunId: PropTypes.string,
    rowNumber: PropTypes.number,
    isSpecial: PropTypes.bool,
    impactedRuns: PropTypes.array,
};
RunDropdown.defaultProps = {
    list: [],
    impactedRuns: [],
};

export default RunDropdown;
